// Main Project — Mega Menu hover wiring
// Hooks Dawn's nav item for "Shop" (by element ID) and reveals the
// matching .mp-mega__panel below the header on hover.
// (Lookbook has no dropdown for now — nav item links directly.)
// Uses a small close-delay so the cursor can travel from the trigger
// into the panel without it disappearing.
(function () {
  function init() {
    const root = document.querySelector('[data-mp-mega]');
    if (!root) return;

    // Map nav-item element IDs → panel keys
    // (Lookbook removed — that nav item links directly to its page.)
    const TRIGGERS = {
      'HeaderMenu-shop': 'shop',
    };

    const panels = {};
    root.querySelectorAll('[data-mp-mega-panel]').forEach(function (p) {
      panels[p.getAttribute('data-mp-mega-panel')] = p;
    });

    let closeTimer = null;

    function open(key) {
      clearTimeout(closeTimer);
      Object.keys(panels).forEach(function (k) {
        panels[k].classList.toggle('is-open', k === key);
      });
      root.setAttribute('aria-hidden', 'false');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        Object.keys(panels).forEach(function (k) { panels[k].classList.remove('is-open'); });
        root.setAttribute('aria-hidden', 'true');
      }, 140);
    }

    // Trigger hover wiring
    Object.keys(TRIGGERS).forEach(function (triggerId) {
      const el = document.getElementById(triggerId);
      if (!el) return;
      const li = el.closest('li') || el;
      const panelKey = TRIGGERS[triggerId];

      li.addEventListener('mouseenter', function () { open(panelKey); });
      li.addEventListener('mouseleave', scheduleClose);
      // Keyboard support — focus opens the panel
      el.addEventListener('focus', function () { open(panelKey); });
    });

    // Keep panel open while the cursor is inside it
    root.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    root.addEventListener('mouseleave', scheduleClose);

    // Esc closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        Object.keys(panels).forEach(function (k) { panels[k].classList.remove('is-open'); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
